import angular from 'angular';
import docDataService from 'app/services/data/doc.data.service';
import controller from './upload-document-dialog.controller';
import template from './upload-document-dialog.html';
import messagesTpl from './upload-document.messages.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions($event, {
    parentFolderId = null,
    parentFolder = null,
    serviceId = null,
    documentId = 0,
    updateCallback = null
  }) {
    return {
      controller,
      controllerAs: 'uploadDocumentDialogVM',
      locals: {
        parentFolderId,
        parentFolder,
        serviceId,
        documentId,
        updateCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.documentManagement.uploadDocumentDialog', [
  ssDialogService,
  loaderService,
  alerts,
  docDataService
])
  .service('uploadDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('upload-document.messages.html', messagesTpl);
  })
  .name;

console.log('app.components.global.documentManagement.uploadDocumentDialog created');
